import { cn } from "@/lib/utils";

const STATUS_COLORS: Record<string, string> = {
  draft: "bg-gray-100 text-gray-700",
  submitted: "bg-blue-100 text-blue-800",
  approved: "bg-indigo-100 text-indigo-800",
  picked: "bg-purple-100 text-purple-800",
  shipped: "bg-cyan-100 text-cyan-800",
  fulfilled: "bg-green-100 text-green-800",
  closed: "bg-gray-200 text-gray-600",
  posted: "bg-green-100 text-green-800",
  pending: "bg-amber-100 text-amber-800",
  active: "bg-blue-100 text-blue-800",
  returned: "bg-green-100 text-green-800",
};

export function StatusBadge({ status }: { status: string }) {
  const key = status.toLowerCase();
  return (
    <span
      className={cn(
        "inline-flex px-2 py-0.5 rounded text-xs font-medium capitalize",
        STATUS_COLORS[key] ?? "bg-muted text-muted-foreground",
      )}
    >
      {status}
    </span>
  );
}
